export default function (input) {
    return input >= 0 ? `+${input}` : input.toString();
}
